<template>
    <div id="overlay">
        <div id="text" class="border">
            <div id="overlayHeader">
                <h2>Détails</h2>
            </div>
            <table id="table" class="table">
                <thead>
                    <tr>
                        <th scope="col">Date</th>
                        <th scope="col">Temps</th>
                        <th scope="col">Projet</th>
                        <th scope="col">Client</th>
                        <th scope="col">Commentaire</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="ev in events" :key="ev.id">
                        <th scope="row" class="text-nowrap">{{ev.date | moment("DD-MM-YYYY") }}</th>
                        <td>{{ev.duration}}</td>
                        <td class="text-nowrap">{{ev.project_name}}</td>
                        <td class="text-nowrap">{{ev.client_name}}</td>
                        <td>{{ev.comment}}</td>
                    </tr>
                </tbody>
            </table>
            <span id="cancel" >
                <b-icon v-on:click="toggleOverlay" icon="x-circle-fill"/>
            </span>
        </div>
    </div>
</template>

<script>

    export default {
        name: "EventDetailsOverlay",
        props: ['events'],
        data() {
            return {
                name: localStorage.name,
            }
        },
        methods: {
            toggleOverlay: function() {
                this.$emit('close');
            },
        },
    };
</script>

<style scoped>
    #overlay {
        position: fixed;
        display: block;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 2;
    }

    #text {
        width: auto;
        position: absolute;
        padding-top: 1em;
        padding-bottom: 1em;
        top: 50%;
        left: 50%;
        color: white;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        background-color: white;
        border-radius: 25px;
    }

    h2 {
        background-color: white;
        color: black;
        width: 80%;
        margin: auto;
    }

    #table {
        width: 100%;
        position: relative;
    }
    #cancel{
        position:absolute;
        top: 0px;
        right: 5px;
        color: red;
        font-size: 30px;
    }
    
    #cancel:hover{
        cursor: pointer;
    }

    @media screen and (max-width: 800px){
        #text{
            width: 90%;
            padding: 5%;
        }
    }

    @media screen and (max-width: 755px){
        #text{
            padding: 0;
            overflow-y: scroll;
        }

        #text table tr>th:first-child{
            display: none;
        }
    }

    @media screen and (max-width: 479px){
        #text{
            width: 60%;
            padding: 5%;
          left: 39.5%;
        }
        .border {
          width: 73% !important;
        }
    }
    
</style>